import axios, { AxiosResponse } from 'axios'
import { Response } from '../../../_metronic/helpers'
import { ISelect } from '../../../coreGlobal/models/default'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const CATEGORY_URL = `${API_URL}/products/categories`
const getCategories = (): Promise<ISelect[] | undefined> => {
  return axios
    .get(`${CATEGORY_URL}/all`)
    .then((response: AxiosResponse<Response<ISelect[]>>) => response.data)
    .then((response: Response<ISelect[]>) => response.data)
}

export { getCategories };
